/**
 * `router/home.js`
 *  - TOPページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {homeRouter} from "./router/home.js";
 */

import { getContainer } from "../utils/index.js";


export const homeRouter = async (data) => {
  console.log("📖 Initializing home page...");

  // KVグラデーションシーンを動的ロード（Three.jsはホームページのみ）
  const { initKvGradient } = await import(
    /* webpackChunkName: "three-kv-gradient" */
    '../modules/three/threeKvGradient.js'
  );
  initKvGradient(data, '#canvas_kv');

  // home_feature / home_concept のスクロール演出 (案 A + D の組合せ)
  await setupSummaryCardAnimations(data);

  // 声紋パーティクルシーン（サンプル・評価用 → SVG揺らぎ採用により無効化）
  // 必要に応じてコメント解除で再検証可能
  // const { initKvVoiceprintParticle } = await import(
  //   /* webpackChunkName: "three-kv-voiceprint-particle" */
  //   '../modules/three/threeKvVoiceprintParticle.js'
  // );
  // initKvVoiceprintParticle(data);
}


/**
 * .home_feature / .home_concept カードのスクロール演出
 *
 *   .{section}_inner に backdrop-filter blur scrub をかけ、進入時の強い霞 →
 *   定常状態 (CSS の blur(8px)) へ収束させる。「ガラスがクリアになっていく」感覚。
 *
 *   range: カード top が viewport bottom → viewport center に到達
 *   blur:  80px → 8px
 */
const setupSummaryCardAnimations = async (data) => {
  const [{ gsap }, ScrollTriggerMod] = await Promise.all([
    import(/* webpackChunkName: "gsap" */ '../modules/gsap/gsap.js'),
    import(/* webpackChunkName: "gsap" */ 'gsap/ScrollTrigger'),
  ]);
  const { ScrollTrigger } = ScrollTriggerMod;
  gsap.registerPlugin(ScrollTrigger);

  const container = getContainer(data);
  if (!container) return;

  // home_feature 1 個 + home_concept 2 個 = 全 3 セクション
  const cards = container.querySelectorAll('.home_feature, .home_concept');

  cards.forEach((card) => {
    const inner = card.querySelector('.home_feature_inner, .home_concept_inner');
    if (!inner) return;

    gsap.fromTo(
      inner,
      { backdropFilter: 'blur(100px)' },
      {
        backdropFilter: 'blur(8px)',
        ease: 'none',
        scrollTrigger: {
          trigger: card,
          start: 'top bottom',
          end: 'center center',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });

  // 動的 import で featureRouter と同様に routeCommon.after の全体 refresh
  // より後に実行された場合に備え、生成直後にもう一度 refresh
  ScrollTrigger.refresh();
};
